export default {
  path: 'correspondent-banks',
  name: 'correspondentBanks',
  component: () => import(/* webpackChunkName: "correspondentBanks" */ '@/views/admin/CorrespondentBanks/index.vue'),
  redirect: { name: 'correspondentBanksList' },
  children: [
    {
      path: 'correspondent-bank-list',
      name: 'correspondentBanksList',
      component: () =>
        import(
          /* webpackChunkName: "correspondentBanksList" */ '@/views/admin/CorrespondentBanks/CorrespondentBanksList.vue'
        ),
    },
    {
      path: 'correspondent-bank-users',
      name: 'correspondentBankUsers',
      component: () =>
        import(
          /* webpackChunkName: "correspondentBankUsers" */ '@/views/admin/CorrespondentBanks/CorrespondentBankUsers.vue'
        ),
    },
  ],
};
